module.exports = __webpack_public_path__ + "static/media/project-thumbnail12.51efdbd4.jpg";